const faceLivenessResolution = {
  width: parseInt(process.env.REACT_APP_USE_LIVENESS_RESOLUTION_HEIGHT) || 640,
  height: parseInt(process.env.REACT_APP_USE_LIVENESS_RESOLUTION_WIDTH) || 480,
};

export default faceLivenessResolution;
